import { WeekNavigationService } from './week-navigation.service';

export default angular
  .module('sfMobile.services.weekNavigation', ['sfMobile.services.dates'])
  .service('weekNavigationService', WeekNavigationService).name;
